import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Loadable from 'react-loadable';
import { Link } from 'redux-little-router';

import { routeMap } from 'router';
import { LoadingWithError } from '../../../../components/Loading/LoadingWithError';

const HelpPage = Loadable({
  loader: () =>
    import(/* webpackChunkName:"chunk-HelpPage" */ '../../../Help/components/HelpContainer'),
  loading: LoadingWithError,
});

export default class Faq extends Component {
  static propTypes = {
    showAccessibilityModal: PropTypes.func.isRequired,
  };

  render() {
    const { showAccessibilityModal } = this.props;

    return (
      <React.Fragment>
        <div className="wrapper">
          <div className="header-wrapper">
            <div className="header header__main content">
              <Link href={routeMap.login} className="header-title">
                <span className="header-title_icon" />
                <span className="header-title_text">
                  Личный кабинет
                  <br /> налогоплательщика
                </span>
              </Link>
              <div className="header_right">
                <div className="header_links">
                  <a
                    className="header_link header_link__eye header_link__mobile js-version-open"
                    title="Версия для слабовидящих"
                    onClick={() => showAccessibilityModal()}
                  >
                    <span className="replace_text">Вид</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="content">
            <HelpPage hideBreadcrumbs={true} />
          </div>
        </div>
        <div className="footer-wrapper footer-wrapper__pages">
          <div className="footer content">
            <div className="footer_left">
              <a href="tel:8-800-222-2222" className="phone">
                8-800-222-2222
              </a>
              <span className="white" style={{ padding: '0 20px 5px', display: 'inline-block' }}>
                {' '}
                Контакт-центр
              </span>
            </div>
            <div className="footer_right">
              <Link href={routeMap.faq} className="link link_support white">
                Помощь
              </Link>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
